<template>
  <div v-bind="$attrs" class="doubleInput" v-on="$listeners">
    <el-date-picker
      v-model="dateObj.startDate"
      :placeholder="startPlaceholder"
      :size="size"
      :disabled="disabled"
      :readonly="readonly"
      :editable="editable"
      :range-separator="rangeSeparator"
      :picker-options="pickerOptionsStart || defalutOptionStart"
      :value-format="$attrs.valueformat"
      type="date"
    />
    <span>{{ rangeSeparator }}</span>
    <el-date-picker
      :default-value="defaultVal"
      v-model="dateObj.endDate"
      :placeholder="endPlaceholder"
      :size="size"
      :readonly="readonly"
      :editable="editable"
      :range-separator="rangeSeparator"
      :picker-options="pickerOptionsEnd || defalutOptionEnd"
      :value-format="$attrs.valueformat"
      type="date"
    />
  </div>
</template>
<script>
import dayjs from 'dayjs'
import props from './tDateProps'
export default {
  name: 'TDate',
  props,
  data () {
    return {
      defalutOptionStart: {
        disabledDate: time => {
          // 获取结束日期的 v-model 值并赋值给新定义的对象
          const endDateVal = this.dateObj.endDate
          if (endDateVal) {
            // 比较 距 1970 年 1 月 1 日之间的毫秒数：
            return time.getTime() >= new Date(endDateVal).getTime()
          }
        }
      },
      defalutOptionEnd: {
        disabledDate: time => {
          // 获取开始日期的 v-model 值并赋值给新定义的对象
          const beginDateVal = this.dateObj.startDate
          if (beginDateVal) {
            // 比较 距 1970 年 1 月 1 日之间的毫秒数：
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1000 * 60 * 60 * 24
            )
          }
        }
      }
    }
  },
  computed: {
    defaultVal () {
      return this.dateObj.startDate
    },
    dateObj: {
      get () {
        return this.$attrs.value || {}
      },
      set () {}
    }
  },
  watch: {
    dateObj: {
      handler (val) {
        if (dayjs(val.startDate).valueOf() > dayjs(val.endDate).valueOf()) {
          val.endDate = ''
        }
        this.$emit('input', val)
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.dateObj = this.$attrs.value
  }
}
</script>

<style lang="less">
.t-date .el-input .el-input__inner {
  padding-right: 0;
}
</style>
<style lang="less" scoped>
.date-picker {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/TDate.vue